import { materialsByJobNumber, updateJobMaterial, createJobMaterial, deleteJobMaterial, restoreJobMaterial } from "@/services/jobMaterials.svc";

const defaultState = () => ({
    list: [],
    jobMaterials: [],
    headers: [
        {
            text: 'Material',
            value: 'Material',
            sortable: true
        },
        {
            text: 'Cost',
            value: 'Cost',
            sortable: false
        },
        {
            text: 'Est Unit Cost',
            value: 'EstUnitCost',
            sortable: false
        },
        {
            text: 'Est Qty',
            value: 'EstQty',
            sortable: false
        },
        {
            text: 'Actual Cost',
            value: 'ActCost',
            sortable: false
        },
        {
            text: 'Actual Qty',
            value: 'ActQty',
            sortable: false
        },
        {
            text: 'Freight',
            value: 'Freight',
            sortable: false
        },
        {
            text: 'Overhead',
            value: 'Overhead',
            sortable: false
        },
        {
            text: 'Received',
            value: 'DateAdded',
            sortable: true
        },
        {
            text: 'Comments',
            value: 'Comments',
            sortable: false
        },        
        {
            text: 'Actions',
            value: 'actions',
            sortable: false
        }
    ],
    adminHeaders: [
        {
            text: 'Material',
            value: 'Material',
            sortable: true
        },
        {
            text: 'Est Qty',
            value: 'EstQty',
            sortable: false
        },
        {
            text: 'Actual Cost',
            value: 'ActCost',
            sortable: false
        },
        {
            text: 'Actual Qty',
            value: 'ActQty',
            sortable: false
        },
        {
            text: 'Freight',
            value: 'Freight',
            sortable: false
        },
        {
            text: 'Overhead',
            value: 'Overhead',
            sortable: false
        },
        {
            text: 'Date Added',
            value: 'DateAdded',
            sortable: true
        },
        {
            text: 'Actions',
            value: 'actions',
            sortable: false
        }
    ],
})

export default {
    namespaced: true,

    state: defaultState(),

    actions: {
        async setMaterialsByJobNumber({ commit }, { jobNumber, showAll = false }) {
            const materials = jobNumber.length > 0 ? await materialsByJobNumber(jobNumber, showAll) : []
            commit('SET_MATERIALS_BY_JOB_NUMBER', materials)
        },

        resetMaterials({ commit }) {
            commit('SET_MATERIALS_BY_JOB_NUMBER', [])
        },

        async createJobMaterialAction({ dispatch }, payload) {
            dispatch('masterboard/incrementMaterialByJobNumber', payload.JobNumber, { root: true })
            return await createJobMaterial(payload)
        },

        async updateJobMaterialAction(_, payload) {
            await updateJobMaterial(payload)
        },

        async deleteJobMaterialAction({ dispatch }, payload) {
            dispatch('masterboard/decrementMaterialByJobNumber', payload.JobNumber, { root: true })
            await deleteJobMaterial(payload.ID, payload.JobNumber)
        },

        async resetJobMaterialAction({ dispatch }, payload) {
            dispatch('masterboard/incrementMaterialByJobNumber', payload.JobNumber, { root: true })
            await restoreJobMaterial(payload.ID, payload.JobNumber)
        },        
    },

    getters: {
        list: (state) => state.list,
        jobMaterials: (state) => state.jobMaterials,
        headers: (state) => state.headers,
        adminHeaders: (state) => state.adminHeaders,
        actMaterialCost: (state) => state.jobMaterials.reduce((sum, item) => {
            const actTotal = item.ActTotal === '0.00' ? (parseInt(item.ActQty) * parseFloat(item.ActCost)): item.ActTotal
            return sum + (parseFloat(actTotal) + parseFloat(item.Freight))
        },0),
        estMaterialCost: (state) => state.jobMaterials.reduce((sum, item) => {
            const estTotal = item.EstTotal === '0.00' ? (parseInt(item.EstQty) * parseFloat(item.EstCost)): item.EstTotal
            return sum + (parseFloat(estTotal) + parseFloat(item.Freight))
        },0),
        overheadCost: (state) => state.jobMaterials.reduce((sum, item) => sum + parseFloat(item.Overhead), 0)
    },

    mutations: {
        SET_LIST(state, payload) {
            state.list = payload
        },

        SET_MATERIALS_BY_JOB_NUMBER(state, payload) {
            state.jobMaterials = payload
        }
    }
}